/*
 * @Author: czj
 * @Date: 2025-04-17 14:50:45
 * @Description: 
 * @FilePath: \sxtracellular-single-cell\src\locales\language\zh.js
 */
export default {
  "name": "中国脑损伤数据图谱",
  "greeting": '你好，世界！',
  "button": {
    "save": '保存',
    "cancel": '取消',
    "confirm": '确定'
  },
  "newTable": {
    "search": '搜索',
    "reset": '重置',
    "back": '返回',
    "more": '更多',
    "noSearch": '暂无搜索',
    "inputPlaceholder": '请输入',
    "selectPlaceholder": '请选择',
    "metaCategory": '元数据分类',
    "viewJson": '查看JSON',
    "yes": '是',
    "no": '否',
    "preview": '预览',
    "noFileSelected": '未选择文件',
    "failedToLoad": '加载失败',
    "copySuccess": '复制成功！',
    "selectPrefix": '请选择',
    "addPrefix": '新增',
    "viewPrefix": '查看',
    "inputPrefix": '请输入',
    "uploadPrefix": '请上传',
    "selectFile": '选择文件',
    "addColumn": '新增列',
    "dataField": '数据字段',
    "displayName": '显示名称',
    "isVisible": '是否显示',
    "dataType": '数据类型',
    "isReadOnly": '是否只读',
    "isSearch": '是否搜索',
    "dataSource": '数据源',
    "actions": '操作',
    "delete": '删除',
    "sourceConfig": '数据源配置',
    "sourceType": '数据源类型',
    "dataTable": '数据表',
    "dictData": '字典数据',
    "label": '标签',
    "matchValue": '匹配值',
    "inputDictName": '请输入字典名称',
    "selectType": '请选择类型',
    "dataError": '当前数据有误，请刷新重试',
    "submitFailed": '提交失败，请联系管理员',
    "configSource": '配置数据源'
  },
  "login": {
    "title": "欢迎回来！",
    "tip": "使用您的账户登录！",
    "email": "电子邮件",
    "password": "密码",
    "login": " 登 录 ",
    "forgot": "没有账号？",
    "signup": "立即注册",
    "retrieve": "忘记密码?"
  },
  "topbar": {
    "logout": "退出登录",
    "signin": "登录",
  },
  "route": {
    "dataset": "数据集",
    "analysis": "分析工具",
    "help": "帮助",
    "contact": "联系我们"
  },
  "home": {
    "dataset": "数据集",
    "cellnum": "细胞数",
    "intro": "简介"
  }
}
